import { useState, useEffect, useMemo } from 'react';
import FarolTerminalForm            from './FarolTerminalForm';
import { useFarol }                 from '../../contexts/FarolPageContext';
import { toSelectOptions }          from '../../utils/reactUtils';
import api                          from '../../services/api.js';

function FarolTerminalFormContainer() {                                                                             

    const { 
        
        handleFarolTerminalModalClose, 
        handleUpdateFarolCards, 
        isFarolTerminalModalOpen, 
        selectedPublicationId, 
        selectedFarolTerminal,
        setSelectedFarolTerminal

    } = useFarol()
    
    const [ _isEditMode,     _setEditMode     ] = useState(false)
    const [ _isLoading,      _setLoading      ] = useState(true)
    const [ _errorMessage,   _setErrorMessage ] = useState(null)

    const [ _terminals,          _setTerminals      ] = useState([])
    const [ _usedTerminalIds,    _setUsedTerminalIds] = useState([])
    const [ _isShipDockered,     _setShipDockered   ] = useState(false)
    const [ _formEditValues,     _setformEditValues ] = useState(null)

    // Terminais que já têm farol nesta publicação ficam desabilitados no select.
    // Na edição, o terminal do próprio farol continua liberado.
    const _terminalOptions = useMemo(() => _terminals.map(terminal => {

        const isUsed = _usedTerminalIds.includes(terminal.value)

        return isUsed ? { ...terminal, isDisabled: true, label: `${terminal.label} (já cadastrado)` } : terminal

    }), [_terminals, _usedTerminalIds])

    const _fetchUsedTerminals = async () => {

        try {

            const response = await api.get(`/getFarolTerminals/${selectedPublicationId}`)
            const { farolTerminals } = response.data

            _setUsedTerminalIds(
                farolTerminals
                    .filter(farolTerminal => farolTerminal.id !== Number(selectedFarolTerminal))
                    .map(farolTerminal => farolTerminal.terminalId)
            )

        } catch (error) {

            _setErrorMessage(`[_fetchUsedTerminals]: ${error.message}`)
        }
    }

    const _fetchTerminalsData = async () => {
        
        if (_terminals.length > 0) return

        try {

            const response = await api.get('/getAllTerminals'); 
            
            if (!response.data) return

            const { terminals } = response.data;

            _setTerminals(toSelectOptions(terminals));
            _setLoading(false)
 
        } catch (error) {

            _setErrorMessage('[_fetchTerminalsData]:', JSON.stringify(error));
        
        }

    }

    const _fetchFarolTerminalData = async (farolTerminalId) => {
        
        try{

            const response = await api.get(`/getFarolTerminalById/${farolTerminalId}`)
            const { farolTerminal } = response.data
            _setformEditValues(farolTerminal)

        }catch(error){

            _setErrorMessage(`[_fetchFarolTerminalData]: ${error.message}`)
        }
    }

    const _handleCloseForm = () => {
    
        handleFarolTerminalModalClose()
        handleUpdateFarolCards()
        
        _setErrorMessage(null)
        setSelectedFarolTerminal(null)
    
    }

    const _handleCreateNewSubmit = async(formData) => {
        
        try{
            
            const response = await api.post('/createFarolTerminal', formData)
            
            if (response.status === 201) _handleCloseForm()

        }catch(error){

            _setErrorMessage(error.response?.status === 409 ? error.response.data.message : `[_fetchFarolTerminalData]: ${error.message}`)
        
        }

    }

    const _handleUpdateSubmit = async(formData) => {
        
        try{
                
            const response = await api.put(`/updateFarolTerminal/${selectedFarolTerminal}`, { newData: formData })
            if (response.status === 200) _handleCloseForm()

        }catch(error){

            _setErrorMessage(error.response?.status === 409 ? error.response.data.message : `[_fetchFarolTerminalData]: ${error.message}`)

        }
    }

    const _handleSubmit = async (formData) => {
    
        try{

            if (!formData.terminalId) return _setErrorMessage('Selecione um terminal.')

            if (_usedTerminalIds.includes(formData.terminalId.id)) {
                return _setErrorMessage('Este terminal já possui um farol nesta publicação.')
            }

            const shipDescription = formData.shipDescription?.trim() || '--'

            const completeFormData = { 
                ...formData, 
                shipDescription,
                isShipDockered: _isShipDockered, 
                scenarioPublicationId: selectedPublicationId, 
                terminalId: formData.terminalId.id 
            }
            
            _isEditMode ? _handleUpdateSubmit(completeFormData) : _handleCreateNewSubmit(completeFormData) 
        
        }catch(error){
            
            _setErrorMessage(`[_handleSubmit]: ${error.message}`)
        
        }

    }

    const _setupEditMode = async () => {

        await Promise.all([ _fetchTerminalsData(), _fetchUsedTerminals(), _fetchFarolTerminalData(selectedFarolTerminal) ]);
        _setEditMode(true);

    }

    const _setupCreateMode = async () => {

        await Promise.all([ _fetchTerminalsData(), _fetchUsedTerminals() ]);
        _setformEditValues(null);
        _setEditMode(false);

    }

    useEffect(() => {
        
        if (!isFarolTerminalModalOpen) return;

        selectedFarolTerminal ? _setupEditMode() : _setupCreateMode()

    }, [isFarolTerminalModalOpen, selectedFarolTerminal]);

    return (

        <FarolTerminalForm

            isOpen={isFarolTerminalModalOpen} 
            onClose={_handleCloseForm} 
            onSubmit={_handleSubmit} 

            isEditMode={_isEditMode} 
            formEditValues={_formEditValues}

            optionsTerminals={_terminalOptions}
             
            isShipDockered={_isShipDockered} 
            setShipDockered={_setShipDockered}

            errorMessage={_errorMessage}
            
        />
    )
}

export default FarolTerminalFormContainer;